import React from 'react';
import { useState, useEffect } from 'react';
import logo from '../../images/logo.png';
import './portal.css';
import { Link } from 'react-router-dom';
import Groups from '../../components/groups/Groups';
import Contacts from '../../components/contacts/Contacts';
import About from '../../components/about/About';
import Polls from '../../components/polls/Polls';
import { Button, Drawer, Layout } from 'antd';
import SideBar from '../../components/sideBar/SideBar';
import { MenuOutlined } from '@ant-design/icons';
import SideMenu from '../../components/sideBar/sideMenu/SideMenu';

const { Header, Content, Footer } = Layout;

interface PortalProps {
    requestUrl: string
    refreshRequestBody: object
}

const UserPortal: React.FC<PortalProps> = ({ requestUrl, refreshRequestBody }) => {
    const [activeTab, setActiveTab] = useState('polls');
    const [visible, setVisible] = useState(false);


    const changeActiveTab = (tabName: string) => {
        return (event: React.MouseEvent) => {
            setActiveTab(tabName);
            setVisible(false)
        }
    }

    const [activeTabComponent, setActiveTabComponent] = useState(
        <Polls 
            changeActiveTab={changeActiveTab} 
            requestUrl={requestUrl}
            refreshRequestBody={refreshRequestBody}
        />
    )

    useEffect(() => {
        const tabs = {
            POLLS: "polls",
            GROUPS: "groups",
            CONTACTS: "contacts",
            ABOUT: "about"
        }

        switch (activeTab) {
            case tabs.POLLS:
                setActiveTabComponent(
                    <Polls 
                        changeActiveTab={changeActiveTab}
                        requestUrl={requestUrl}
                        refreshRequestBody={refreshRequestBody}
                        />);
                break;
            case tabs.GROUPS:
                setActiveTabComponent(<Groups/>);
                break;
            case tabs.CONTACTS:
                setActiveTabComponent(<Contacts/>);
                break;
            case tabs.ABOUT:
                setActiveTabComponent(<About/>);
                break;
            
        }
    }, [activeTab, requestUrl, refreshRequestBody ])  
    
    const removeCookies = () => {
            window.localStorage.removeItem('access');
            window.localStorage.removeItem('refresh');

    }

    return(
        <Layout className="site-layout-background">
            <Header className="navbar-layout-background" >
                <div className='navbar-content'>
                    <div className='logo-area'>
                        <Button
                            className="menu"
                            type="text"
                            icon={<MenuOutlined/>}
                            onClick={() => setVisible(true)}
                        />
                        <Drawer
                            title="FairVote"
                            placement="left"
                            onClose={() => setVisible(false)}
                            visible={visible}
                        > 
                            <SideMenu changeActiveTab={changeActiveTab}/>
                        </Drawer>
                        <Link to='/' style={{ textDecoration: 'none' }}>
                            <img className='logo' alt='logo' src={logo} />
                        </Link>
                        <Link to='/' style={{ textDecoration: 'none' }}>
                            <h1 className='brand-name'>FairVote</h1>
                        </Link>
                    </div>
                    <Link to='/' style={{ textDecoration: 'none' }}>
                        <Button className='logout-button' type="link" onClick={removeCookies}>
                            Log Out
                        </Button>
                    </Link> 
                </div>
            </Header>
            <Content className='page-content'>
                <Layout className='content_layout'>
                    <SideBar changeActiveTab={changeActiveTab}/>
                    <Content className="site-layout-background rendered-content">
                        {activeTabComponent}
                    </Content>          
                </Layout>
            </Content>
            <Footer className="site-layout-background" style={{ textAlign: 'center' }}>FairVote ©2021 Created by FairVote</Footer>
        </Layout>
    )
}

export default UserPortal;